import type { DecodedToken } from '@/types';
import { pushRegister } from '@/lib/analytics';

const REGISTER_PROCESSED_KEY = 'auth_register_processed_auth_time';

/**
 * Pushes the GTM `register` event when the decoded token has
 * `new_registration` set to `"true"`. Fires at most once per auth session
 * (deduplicated by `auth_time` in localStorage). The token is decoded once
 * in `AuthProvider` and passed in to avoid decoding it twice.
 */
export function trackAuthAnalytics(decoded: DecodedToken): void {
  if (typeof window === 'undefined') return;

  if (decoded.new_registration !== 'true') return;

  const authTime = decoded.auth_time;
  if (authTime == null) return;

  const authTimeKey = String(authTime);
  if (localStorage.getItem(REGISTER_PROCESSED_KEY) === authTimeKey) return;

  localStorage.setItem(REGISTER_PROCESSED_KEY, authTimeKey);
  pushRegister();
}
